import type { FilterOptionViewModel } from 'autogen/swagger/all';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Sorting } from 'autogen/translation-keys/trans-website-filter';
import SortingFilterOption from './SortingFilterOption';
import FilterMenuSmartView from '../../FilterMenu/FilterMenuSmartView';
import { FilterMenuFooterSimple } from '../../FilterMenu/components/FilterMenuFooter';

export const sortingFilterMenuId = 'sorting-menu';

const SortingFilterMenu = ({ model: options }: { model: FilterOptionViewModel[] }) => {
    const filterMenuId = sortingFilterMenuId;
    const { t } = useTranslation();

    return (
        <FilterMenuSmartView
            name={filterMenuId}
            headline={t(Sorting)}
            footerRenderer={() => <FilterMenuFooterSimple />}
        >
            {options.map((option) => (
                <SortingFilterOption key={option.displayName} model={option} />
            ))}
        </FilterMenuSmartView>
    );
};

export default memo(SortingFilterMenu);
